// extracted by mini-css-extract-plugin
export default {"contents":"mG-z","sectionHeading":"nG-z"};